import { createSlice } from "@reduxjs/toolkit";

const initialMatrixTypeState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  matrixTypeForEdit: undefined,
  lastError: null,
  message: null,
  error: null,
};
export const callTypes = {
  list: "list",
  action: "action",
};

export const matrixTypeSlice = createSlice({
  name: "matrixTypes",
  initialState: initialMatrixTypeState,
  reducers: {
    catchError: (state, action) => {
      state.error = action.payload.error.clientMessage;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      state.message = null;

      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    endCall: (state, action) => {
      state.error = null;
      state.message = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    // getMatrixTypeById
    matrixTypeFetched: (state, action) => {
      state.actionsLoading = false;
      state.matrixTypeForEdit = action.payload.matrixTypeForEdit;
      state.error = null;
    },
    // getMatrixTypeChart
    matrixTypeChartFetched: (state, action) => {
      state.actionsLoading = false;
      state.matrixTypeChart = action.payload.matrixTypeChart;
      state.error = null;
    },
    // getMatrixTypeChart
    matrixTypeHourlyChartFetched: (state, action) => {
      state.actionsLoading = false;
      state.matrixTypeChartHour = action.payload.matrixTypeChartHour;
      state.error = null;
    },
    // getMatrixTypeChart
    matrixTypeHourlyZoneChartFetched: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
    },
    // get list data
    matrixTypesFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
      state.matrixTypeForEdit = undefined;
    },
    // createMatrixType
    matrixTypeCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.message = action.payload.msgResponse;
    },
    // updateMatrixType
    matrixTypeUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.message = action.payload.msgResponse;
    },
    // matrixTypeDeleted
    matrixTypeDeleted: (state, action) => {
      state.error = null;
      state.message = action.payload.msgResponse;
      state.actionsLoading = false;
    },
    setMessage: (state, action) => {
      state.error = null;
      state.message = action.payload.msgResponse;
    },
  },
});
